module.exports = __webpack_public_path__ + "/images/SharePoint_site.png";